import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { usePageMeta } from "@/hooks/usePageMeta";

const areas = ["Brand & marketing", "Sales & distribution", "Retail operations", "Product & category development", "Supply chain & sourcing", "Finance & administration"];

export default function Careers() {
  usePageMeta("Careers", "Explore career opportunities with Suvirika Retail Pvt Ltd and share your profile for future roles across our brands.");
  return (
    <>
      <PageHero
        eyebrow="Careers"
        lines={["Build brands", <em key="i" className="italic font-light text-rose-ink">with us.</em>]}
        intro="As our portfolio grows, we look for people who enjoy practical problem-solving, care about customers, and want to help build distinct consumer brands."
        testId="careers-hero"
      />
      <section className="pb-16">
        <div className="container-x grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden arch">
              <img src="/images/b-99distributor.jpg" alt="Warehouse aisle with stocked racks" loading="lazy" className="h-full w-full object-cover" />
            </div>
          </Reveal>
          <div className="lg:col-span-7 lg:pl-8">
            <Reveal><p className="eyebrow">Areas of work across the group</p></Reveal>
            <ul className="mt-6 border-t hairline">
              {areas.map((a, i) => (
                <Reveal as="li" key={a} delay={i * 0.05} className="flex items-baseline justify-between border-b hairline py-5">
                  <span className="text-lg">{a}</span>
                  <span className="font-mono-label text-xs text-[var(--ink-2)]">0{i + 1}</span>
                </Reveal>
              ))}
            </ul>
            <Reveal delay={0.1}>
              <div className="mt-10 border-l-2 border-[var(--sky)] pl-5" data-testid="careers-openings-note">
                <p className="font-semibold">No open positions are listed right now.</p>
                <p className="mt-1 text-[var(--ink-2)]">You are welcome to share your profile below and we will reach out when a relevant opportunity opens.</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="container-x">
          <Reveal className="border hairline bg-white p-6 md:p-12">
            <h2 className="font-display text-3xl">Share your profile</h2>
            <p className="mt-2 mb-10 text-[var(--ink-2)]">Tell us about your experience and the kind of role you are interested in.</p>
            <EnquiryForm defaultType="Careers & Professional Opportunities" defaultBrand="Suvirika Retail (Group)" testId="careers-form" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
